// 공통
import commScss1 from "@/assets/common/scss/_Sweetalert.scss?inline";
import commScss2 from "@/assets/common/scss/settings.scss?inline";
import commBread from "@/assets/common/scss/breadcrumb.scss?inline";

import commCss1 from "@/assets/common/css/common_ui.css?inline";
import commCss2 from "@/assets/common/css/dl_global.css?inline";
import commCss3 from "@/assets/common/css/normalize.css?inline";
import commCss4 from "@/assets/common/css/grid.css?inline";
import commCss5 from "@/assets/common/css/formstyle.css?inline";
import commCss6 from "@/assets/common/css/table.css?inline";
import commCss7 from "@/assets/common/css/ui.css?inline";
import commCss8 from "@/assets/common/css/popup.css?inline";
import commDashBoard from "@/assets/common/css/dashboard.css?inline";
import editorViewCss from "@/assets/common/css/tiny-editor-view.css?inline";

import commDiag from "@/assets/common/css/diag.css?inline";
import commEcp from "@/assets/common/css/ecp.css?inline";
import commEmploy from "@/assets/common/css/employ.css?inline";
import commCareer from "@/assets/common/css/career.css?inline";
import commCommu from "@/assets/common/css/community.css?inline";
import commCounsel from "@/assets/common/css/counsel.css?inline";
import commMileage from "@/assets/common/css/mileage.css?inline";
import commMypage from "@/assets/common/css/mypage.css?inline";
import commPortfolio from "@/assets/common/css/portfolio.css?inline";
import commStdinfo from "@/assets/common/css/stdinfo.css?inline";
import commAiEcp from "@/assets/common/css/ai_ecp.css?inline";
import "swiper/css/pagination";

// student
// import studentCmmnCss1 from "@/assets/student/css/common_ui.css?inline";

// student inha (인하대)
import inhaCommCss1 from "@/assets/inha/css/common_ui.css?inline";
import inhaDashBoard from "@/assets/inha/css/dashboard.css?inline";
import inhaOverview from "@/assets/inha/css/overview.css?inline";

// student dongwon (동원과기대)
import dongwonCommCss1 from "@/assets/dongwon/css/common_ui.css?inline";
import dongwonDashBoard from "@/assets/dongwon/css/dashboard.css?inline";

const styleElements = new Map<string, HTMLStyleElement[]>();

// 공통 스타일 정의
const commonStyles = {
  commCss1,
  commCss2,
  commCss3,
  commCss4,
  commCss5,
  commCss6,
  commCss7,
  commCss8,
  commScss1,
  commScss2,
  commBread,
  commDashBoard,
  editorViewCss,
  commDiag,
  commEcp,
  commEmploy,
  commCareer,
  commCommu,
  commCounsel,
  commMileage,
  commMypage,
  commPortfolio,
  commStdinfo,
  commAiEcp,
  // 인하대 css
  inhaCommCss1,
  inhaDashBoard,
  inhaOverview,
  // 동원과기대 css
  dongwonCommCss1,
  dongwonDashBoard,
};

// 각 테마별 스타일 직접 바인딩
const styleMap: Record<string, Record<string, string>> = {
  common: {
    ...commonStyles,
  },
  student: {
    ...commonStyles,
  },
  staff: {
    ...commonStyles,
  },
};

export const useDynamicStyle = () => {
  const applyStyle = (key: string): void => {
    const styles = styleMap[key];
    if (!styles) {
      console.warn(`스타일 '${key}' 없음`);
      return;
    }

    console.info(`🔄 ${key} 스타일 적용 시작`);

    // 기존 스타일 제거
    styleElements.forEach((elements) => {
      elements.forEach((el) => el.remove());
    });
    styleElements.clear();

    document.querySelectorAll("style[data-dynamic-style]").forEach((el) => el.remove());

    // 새 스타일 적용
    const newElements: HTMLStyleElement[] = [];

    console.info(`📁 ${key} 파일들:`, Object.keys(styles));

    Object.entries(styles).forEach(([fileName, cssContent]) => {
      const styleElement = document.createElement("style");
      styleElement.setAttribute("data-dynamic-style", key);
      styleElement.setAttribute("data-file", fileName);
      styleElement.textContent = `/* ${key}: ${fileName} */\n${cssContent}`;

      document.head.appendChild(styleElement);
      newElements.push(styleElement);
    });

    styleElements.set(key, newElements);
    console.info(`✅ ${key} 적용 완료: ${newElements.length}개 파일`);
  };

  const removeStyle = (key: string): void => {
    const elements = styleElements.get(key);
    if (elements) {
      elements.forEach((el) => el.remove());
      styleElements.delete(key);
      console.info(`🗑️ ${key} 스타일 제거 완료`);
    }
  };

  const removeAllStyles = (): void => {
    styleElements.forEach((elements) => {
      elements.forEach((el) => el.remove());
    });
    styleElements.clear();
    console.info(`🗑️ 모든 동적 스타일 제거 완료`);
  };

  return {
    applyStyle,
    removeStyle,
    removeAllStyles,
  };
};

export const loadStyleBySite = (site?: string): void => {
  // 기존 css 링크 제거
  const linkElement = document.getElementById("site-css") as HTMLLinkElement;
  if (linkElement) linkElement.remove();

  if (!site) return;

  // site별 css 동적 로드
  const newLinkElement = document.createElement("link");
  newLinkElement.rel = "stylesheet";
  newLinkElement.href = `/src/assets/${site}/${site}_default.css`;
  newLinkElement.id = "site-css";

  // 에러 로깅
  newLinkElement.onerror = () => {
    console.warn(`[CSS NOT FOUND] ${newLinkElement.href}`);
    linkElement.remove(); // 깨진 링크 제거
  };

  // 헤드에 추가
  document.head.appendChild(newLinkElement);
};
